<template>
  <div :class="[baseCss]" :style="{aspectRatio}">
    <iframe @load="$emit('ready')" style="width: 100%; height: 100%" :src="src" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import calculateAspectRatio from 'calculate-aspect-ratio'

export default {
  name: 'Vid',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('vid', []),
      aspectRatio: null
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.setAspectRatio()
  },
  methods: {
    setAspectRatio () {
      this.aspectRatio = calculateAspectRatio(this.width, this.height).split(':').join('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/vid/vid.vue